import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
} from "react-router-dom";
import App from "../App";
import { Layout } from "../components/Layout";
import Dashboard from "../Dashboard/Dashboard";
import Tables from "../Tables/Tables";
import TablePageComponent from "../Table/TablePageComponent";
import Certification from "../Certification/Certification";
import Remittance from "../Remittance/Remittance";
//import Attendance from "../Attendance/Attendance";
import Invoice from "../Invoice/Invoice";
import Batches from "../Batches/Batches";
import Students from "../Students/Students";
import LoginPage from "../Login/LoginPage";
import { Utilities } from "./utilities";
import Package from "../Package/Package";
import AllMou from "../AllMou/AllMou";
import BatchJourney from "../Batches/Journey/BatchJourney";
import JourneyIssuesDashboard from "../Batches/Journey/JourneyIssuesDashboard";
import RecentChanges from "../Batches/Journey/RecentChanges";
import BatchSessions from "../BatchSessions/BatchSessions";
import TrainerReferral from "../Trainerreferral/Trainerreferral";
import RecordingTracker from "../RecordingTracker/RecordingTracker"
import PrivacyPolicy from "../Legal/PrivacyPolicy";
import TermsOfService from "../Legal/TermsOfService";
import AzureRedirectHandler from "../auth/AzureRedirectHandler";
import AdminManagement from "../admin-management/adminManagement"; 
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      {/* Protected Routes */}
      <Route path="" element={<Layout />}>
        {/* Default redirect → /dashboard */}
        <Route index element={<Navigate to="/dashboard" replace />} />

        {/* Main Pages */}
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="Certification" element={<Certification />} />
        <Route path="Remittance" element={<Remittance />} />
        <Route path="Invoice" element={<Invoice />} />
        <Route path="Batches" element={<Batches />} />
        <Route path="batches/:batchNo/journey" element={<BatchJourney />} />
        {/* <Route path="Attendance" element={<Attendance />} /> */}
        <Route path="Students" element={<Students />} />
        <Route path="Package" element={<Package />} />
        <Route path="AllMou" element={<AllMou />} />
        <Route path="journey-issues-dashboard" element={<JourneyIssuesDashboard />} />
        <Route path="recent-changes" element={<RecentChanges />} />
        <Route path="batch-sessions" element={<BatchSessions />} />
        <Route path="trainer-referral" element={<TrainerReferral />} />
        <Route path="recording-tracker" element={<RecordingTracker />} />
       <Route path="admin-management" element={<AdminManagement />} />
        



        {/* Tables */}
        <Route path="tables" element={<Tables />}>
          {Utilities.tablesToShow.map((table) => (
            <Route
              key={table.name.plural}
              path={table.name.plural}
              element={
                <TablePageComponent key={table.name.plural} tableData={table} />
              }
            />
          ))}
        </Route>
      </Route>

      {/* Public Routes */}
      <Route path="login" element={<LoginPage />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="terms-of-service" element={<TermsOfService />} />

      {/* MSAL SSO redirectUri target — must not navigate away, see AzureRedirectHandler */}
      <Route path="redirect/azure" element={<AzureRedirectHandler />} />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Route>,
  ),
);
